var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8362 18.839H16.1707V14.6622C16.1707 13.6662 16.1505 12.3845 14.7817 12.3845C13.392 12.3845 13.1797 13.4683 13.1797 14.5887V18.839H10.5142V10.25H13.0747V11.4207H13.1092C13.467 10.7457 14.337 10.0332 15.6367 10.0332C18.3375 10.0332 18.837 11.8108 18.837 14.1245L18.8362 18.839ZM7.50373 9.07475C6.64573 9.07475 5.95648 8.38025 5.95648 7.526C5.95648 6.6725 6.64648 5.97875 7.50373 5.97875C8.35873 5.97875 9.05173 6.6725 9.05173 7.526C9.05173 8.38025 8.35798 9.07475 7.50373 9.07475ZM8.84023 18.839H6.16723V10.25H8.84023V18.839ZM20.1697 3.5H4.82923C4.09498 3.5 3.50098 4.0805 3.50098 4.79675V20.2033C3.50098 20.9202 4.09498 21.5 4.82923 21.5H20.1675C20.901 21.5 21.501 20.9202 21.501 20.2033V4.79675C21.501 4.0805 20.901 3.5 20.1675 3.5H20.1697Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.64b61ce7d951e968be73c6bb8d820d75.svg";
export { ForwardRef as ReactComponent };